import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { catalog } from '@/mocks/catalog';
import { ratingLabel } from '@/utils/format';

const featured = catalog.filter((item) => item.featured);

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const total = featured.length;

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((i) => (i + 1) % total);
    }, 6000);
    return () => clearInterval(timer);
  }, [total]);

  const go = (next: number) => setIndex((next + total) % total);
  const current = featured[index];

  return (
    <section aria-label="焦点推荐" className="mt-4 md:mt-6">
      <div className="relative w-full h-[440px] md:h-[560px] rounded-lg overflow-hidden bg-primary-950">
        {featured.map((item, i) => (
          <div
            key={item.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              i === index ? 'opacity-100' : 'opacity-0 pointer-events-none'
            }`}
          >
            <img
              src={item.backdrop}
              alt={`${item.title}剧照`}
              title={`${item.title} - ${item.genres.join(' ')}`}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950/95 via-primary-950/70 to-primary-950/20"></div>
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-transparent to-transparent"></div>
          </div>
        ))}

        <div className="relative z-10 h-full w-full flex flex-col justify-end md:justify-center px-6 md:px-14 pb-16 md:pb-0 max-w-[760px]">
          <div className="flex items-center gap-2 mb-3">
            <span className="px-2.5 py-1 rounded-md bg-accent-500 text-foreground-950 text-xs font-semibold">
              {current.type === 'movie' ? '热门电影' : '热门剧集'}
            </span>
            <span className="flex items-center gap-1 px-2.5 py-1 rounded-md bg-background-50/15 text-background-50 text-xs font-label">
              <i className="ri-fire-line text-accent-400"></i>
              {ratingLabel(current.rating)} 分
            </span>
          </div>
          <h2 className="font-heading font-extrabold text-3xl md:text-5xl text-background-50 leading-tight">
            {current.title}
          </h2>
          <p className="mt-3 text-sm md:text-base text-background-100/90 line-clamp-2 max-w-[560px]">
            {current.summary}
          </p>
          <p className="mt-4 text-xs md:text-sm text-background-200/80">
            {current.year} · {current.region} · {current.genres.join(' / ')} · 导演 {current.director}
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <Link
              to={`/detail/${current.id}`}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-accent-500 hover:bg-accent-600 text-foreground-950 text-sm font-semibold transition-colors whitespace-nowrap"
            >
              <i className="ri-information-line"></i>
              查看详情
            </Link>
            <Link
              to={`/category/${current.type}`}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-50/40 hover:bg-background-50/10 text-background-50 text-sm font-medium transition-colors whitespace-nowrap"
            >
              <i className="ri-grid-line"></i>
              更多{current.type === 'movie' ? '电影' : '电视剧'}
            </Link>
          </div>
        </div>

        {/* controls */}
        <button
          type="button"
          onClick={() => go(index - 1)}
          aria-label="上一张"
          className="absolute z-20 left-3 md:left-6 top-1/2 -translate-y-1/2 w-9 h-9 md:w-10 md:h-10 rounded-full bg-background-950/40 hover:bg-background-950/70 text-background-50 flex items-center justify-center transition-colors"
        >
          <i className="ri-arrow-left-s-line text-2xl"></i>
        </button>
        <button
          type="button"
          onClick={() => go(index + 1)}
          aria-label="下一张"
          className="absolute z-20 right-3 md:right-6 top-1/2 -translate-y-1/2 w-9 h-9 md:w-10 md:h-10 rounded-full bg-background-950/40 hover:bg-background-950/70 text-background-50 flex items-center justify-center transition-colors"
        >
          <i className="ri-arrow-right-s-line text-2xl"></i>
        </button>

        <div className="absolute z-20 bottom-5 left-6 md:left-14 flex items-center gap-2">
          {featured.map((item, i) => (
            <button
              key={item.id}
              type="button"
              onClick={() => setIndex(i)}
              aria-label={`切换到 ${item.title}`}
              className={`h-1.5 rounded-full transition-all ${
                i === index ? 'w-7 bg-accent-500' : 'w-3 bg-background-50/50 hover:bg-background-50/80'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}